<div class="container">
    <p>{{ 'NO_ACCESS' | translate }}</p>
</div>